import { toStandardResult } from "../util/graphql.js";
import { useQuery } from "@apollo/react-hooks";

import gql from "graphql-tag";

const trainingCourseSchema = `
  id
  code
  name
  description
  price {
    amountExclTax
    amountInclTax
  }
`;

// Catalogue toujours court : chargé en une seule requête, sans pagination.
export function useTrainingCourses() {
  const result = useQuery(
    gql`
      query GET_TRAINING_COURSES {
        private {
          trainings {
            trainingCourses: fetchTrainingCourses {
              ${trainingCourseSchema}
            }
          }
        }
      }
    `,
  );

  return toStandardResult(result, "private.trainings.trainingCourses");
}
